import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import Password from "./components/Password";
import PasswordSettings from "./components/PasswordSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/password_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'password', // 插件名，不能包含空格,空格用-代替
    group: ElementGroup.INPUT, // 插件所在组，默认为ElementGroup.CUSTOM
    target: defaultTarget, // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages['PAGEBUIDER_ELEMENT_FORM_PASSWORD'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: { // 插件初始化数据
      formItemSettings: {
        allowClear: true,
        bordered: true,
        visibilityToggle: true,
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_PASSWORD']
      },
      settings: {
        width: {
          value: "100%"
        },
      }
    },
    pluginComponent: Password, // 插件渲染组件
    pluginSettingComponent: PasswordSettings, // 插件设置项组件
  }
}
